import { PageContext } from "./PageContext";

export enum DeviceType {
  DESKTOP = "DESKTOP",
  TABLET = "TABLET",
  MOBILE = "MOBILE",
  OTHER = "OTHER",
}

export interface ConnectionOptions {
  pageContext: PageContext;
  language?: "en" | string;
  deviceType?: DeviceType;
}
